import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

interface SidebarItem {
  icon: string;
  label: string;
  path: string;
}

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent {
  readonly menuItems: SidebarItem[] = [
    { icon: '▦', label: 'Dashboard', path: '/admin' },
    { icon: '□', label: 'Products', path: '/admin/products' },
    { icon: '✎', label: 'Website Content', path: '/admin/content' },
    { icon: '⚙', label: 'Settings', path: '/admin/settings' },
  ];

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {}

  async logout(): Promise<void> {
    await this.authService.logout();
    await this.router.navigateByUrl('/admin/login');
  }

  trackByMenu(_: number, item: SidebarItem): string {
    return item.label;
  }
}
